"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStage = void 0;
let stage = 'local';
const envConfig = {
    test: {
        stage: 'test',
        backend: {
            base_url: 'http://192.168.68.109:5001/fdtigermaster-dev/us-central1',
        }
    },
    local: {
        stage: 'local',
        backend: {
            base_url: 'http://192.168.68.109:5001/fdtigermaster-dev/us-central1',
        }
    },
    develop: {
        stage: 'develop',
        backend: {
            // base_url: 'http://192.168.7.100:5001/fdtigermaster-dev/us-central1',
            base_url: 'https://us-central1-fdtigermaster-dev.cloudfunctions.net',
        }
    },
    staging: {
        stage: 'staging',
        backend: {
            base_url: 'https://asia-northeast1-fdtigermaster-stg.cloudfunctions.net',
        }
    },
    production: {
        stage: 'production',
        backend: {
            base_url: 'https://asia-east1-fdtigermaster-pro.cloudfunctions.net',
        }
    }
};
const setStage = (s) => {
    stage = s;
};
exports.setStage = setStage;
exports.default = () => {
    return envConfig[stage];
};
//# sourceMappingURL=Config.js.map